import Head from 'next/head';
import { NextSeo } from 'next-seo';
import { SWRConfig } from 'swr';
import RankPredictor from '@cont/RankPredictor/CAT/CatRankPredictor';
import { RANK_PREDICTOR } from '@constants/segment';
import Layout from '@layout/FreeLayout/FreeLayout';
import fetchPageMetaInfo from '@api/fetchers/pageMetaInfo';
import { fetchGoalInfo } from '@api/fetchers/goal';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import { CAT_PERCENTILE_PREDICTOR_DEFAULT_META } from '@cont/RankPredictor/CAT/constants';

const CAT_GOAL_UID = 'XNDUS';

const CATRankPredictorLanding = ({ pageMetaInfo, fallbackData }) => {
  const metaTitle =
    pageMetaInfo?.title || CAT_PERCENTILE_PREDICTOR_DEFAULT_META.title;
  const description =
    pageMetaInfo?.description ||
    CAT_PERCENTILE_PREDICTOR_DEFAULT_META.description;
  const { key: goalSWRKey } = useGoalInfo(CAT_GOAL_UID, {
    fallbackData: fallbackData.goalInfo
  });
  return (
    <>
      <SWRConfig
        value={{
          revalidateOnMount: false,
          dedupingInterval: 60 * 1000,
          fallback: {
            [goalSWRKey]: fallbackData?.goalInfo
          }
        }}
      >
        <NextSeo
          title={metaTitle}
          description={description}
          openGraph={{
            title: metaTitle,
            description
          }}
        />
        <Head>
          <title>CAT Percentile Calculator</title>
        </Head>
        <RankPredictor />
      </SWRConfig>
    </>
  );
};

CATRankPredictorLanding.pageInfo = {
  isMWebSupported: true,
  name: RANK_PREDICTOR,
  layoutOptions: {
    hideHeader: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export const getStaticProps = async () => {
  try {
    const [metaInfo, goalInfo] = await Promise.all([
      fetchPageMetaInfo(RANK_PREDICTOR, CAT_GOAL_UID),
      fetchGoalInfo(CAT_GOAL_UID)
    ]);
    return {
      props: {
        fallbackData: {
          goalInfo
        },
        pageMetaInfo: metaInfo || null
      }
    };
  } catch {
    return { notFound: true, revalidate: 60 };
  }
};

export default CATRankPredictorLanding;
CATRankPredictorLanding.Layout = Layout;
CATRankPredictorLanding.Wrapper = null;
